
import React from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import App from "./App";

const container = document.getElementById("root");

const app = (
  <React.StrictMode>
      <App />
  </React.StrictMode>
);

// react-snap leaves prerendered HTML inside #root.
// Remove it before mounting React because this application contains
// browser-dependent content that cannot be hydrated reliably.
while (container.firstChild) {
  container.removeChild(container.firstChild);
}

createRoot(container).render(app);

